export enum ResidentStatus {
  Departed = 'Departed',
  ActiveResident = 'Active Resident',
  UsingMyHub = 'Using',
  NotUsingMyHub = 'Not Using'
}